import { openDatabase } from "../Utils/db";
import type { IUserDB } from "../interfaces/User";

const USER_ID_KEY = "@Eriol/system/userId";

class CurrentUser {
  getUserId(): string | null {
    return localStorage.getItem(USER_ID_KEY);
  }

  async getLang(): Promise<string | null> {
    const user = await this.getUser();
    return user?.lang ?? null;
  }

  async getUser(): Promise<IUserDB | undefined> {
    const db = await openDatabase();
    const users = (await db?.user.toArray()) || [];
    return users?.[0];
  }
}

export default new CurrentUser();
